<template>
    <div v-loading="loading">
        <div class="m-portlet m-b-10" :style="{'height':100+'px'}">
            <div class="m-portlet__body">
                <el-form label-position="right" label-width="90px">
                    <el-row :gutter="10">
                        <el-col :span="6">
                            <el-date-picker
                                    v-model="date"
                                    type="date"
                                    :clearable="false"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                    @change="handleShow()">
                            </el-date-picker>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="m-portlet m-b-10" :style="{'height':200+'px'}">
            <div class="m-portlet__body">
                <div style="font-size: 15px;height: 30px">上课通知</div>
                <el-form label-position="right" label-width="90px">
                    <el-row :gutter="10">
                        <el-col :span="2" v-for="start_time in orderStartTimes">
                            <el-button :title="start_time.class_number" @click="sendingStartEmail(start_time.time)">{{start_time.time}}</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="m-portlet m-b-10" :style="{'height':200+'px'}">
            <div class="m-portlet__body">
                <div style="font-size: 15px;height: 30px">下课通知</div>
                <el-form label-position="right" label-width="90px">
                    <el-row :gutter="10">
                        <el-col :span="2" v-for="end_time in orderEndTimes">
                            <el-button :title="end_time.class_number" @click="sendingEndEmail(end_time.time)">{{end_time.time}}</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Index",
        data() {
            return {
                path:'/student/courseNotify/email',
                loading: 'true',
                date:this.$moment().format('YYYY-MM-DD'),
                start_times: [],
                end_times:[],
            }
        },
        props: {},
        created() {
            this.handleCreate();
            this.handleShow();
        },
        computed: {
            orderStartTimes: function () {
                return this._.orderBy(this.start_times, 'time', 'asc');
            },
            orderEndTimes: function () {
                return this._.orderBy(this.end_times, 'time', 'asc');
            }
        },
        beforeDestroy(){
            this.$wApi.removeListen(this.path);
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        this.start_times=data.start_times
                        this.end_times=data.end_times
                        this.loading=false
                        setTimeout(() => {
                            this.handleShow();
                        }, 10000)
                        break;
                    case 'sending_start_email':
                        this.$message({
                            message: '上课通知发送成功',
                            type: 'success'
                        });
                        break;
                    case 'sending_end_email':
                        this.$message({
                            message: '下课通知发送成功',
                            type: 'success'
                        });
                        break;
                }
            },
            handleShow() {
                this.loading=true
                this.$wApi.send(this.path, 'init', {'date':this.date});
            },
            sendingStartEmail(start_time){
                this.$wApi.send(this.path, 'sending_start_email', {'date':this.date,'start_time':start_time});
            },
            sendingEndEmail(end_time){
                this.$wApi.send(this.path, 'sending_end_email', {'date':this.date,'end_time':end_time});
            }
        }
    }
</script>

<style scoped>

</style>